export default __webpack_public_path__ + "media/6354b06bd4aede7235f0acf092a6098cd973ef8a2c7bb7b25804c3d1ef1c99b1.svg";